import { Component } from '@angular/core';
import { FirebaseService } from './services/firebase.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.less']
})
export class AppComponent {
	public isLogin: boolean = false;
	public user;
	constructor(
		private firebaseService: FirebaseService
	) {

	}
}


// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/app.component.ts